var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#FB7185",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FB7185",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 20.8333H37.6663M24.333 26.1667V34.1667M29.6663 26.1667V34.1667M17.6663 20.8333L18.9997 36.8333C18.9997 37.5406 19.2806 38.2189 19.7807 38.719C20.2808 39.219 20.9591 39.5 21.6663 39.5H32.333C33.0403 39.5 33.7185 39.219 34.2186 38.719C34.7187 38.2189 34.9997 37.5406 34.9997 36.8333L36.333 20.8333M22.9997 20.8333V16.8333C22.9997 16.4797 23.1402 16.1406 23.3902 15.8905C23.6402 15.6405 23.9794 15.5 24.333 15.5H29.6663C30.02 15.5 30.3591 15.6405 30.6091 15.8905C30.8592 16.1406 30.9997 16.4797 30.9997 16.8333V20.8333",
    stroke: "#F90808",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/deleteSvg.8d1323ca1f2c3cf2b3a9d24aa1c1efe2.svg";
export { ForwardRef as ReactComponent };